import {observer} from 'mobx-react';
import {Checkbox} from 'shared/components';

const SelectionCheckboxCell = observer(({
  viewModel,
  selectionState,
  horizontalScroll,
}) => {
  return (
    <div
      className={`AccordionTableCell flex align-items-middle ${horizontalScroll ? '' : 'accordion-col-1'}`}
      style={horizontalScroll ? {minWidth: '4rem'} : {}}
    >
      <Checkbox
        checked={selectionState.isChecked(viewModel)}
        onChange={() => selectionState.toggle(viewModel)}
      />
    </div>
  );
});

export default SelectionCheckboxCell;
